<ui-confirmation-dialog
    header="time-tracking.confirmAction"
    primaryButtonLabel="delete"
    primaryButtonType="danger"
    secondaryButtonLabel="cancel"
    #confirmDeleteModal
>
    <p>{{ 'time-tracking.confirmDeleteProject' | translate }}</p>
</ui-confirmation-dialog>

<ui-confirmation-dialog
    header="time-tracking.confirmAction"
    primaryButtonLabel="archive"
    primaryButtonType="danger"
    secondaryButtonLabel="cancel"
    #confirmArchiveModal
>
    <ui-banner
        *ngIf="projectToArchive?.hasPendingTimesheetEntries"
        class="banner margin-bottom-2 align-left"
        variant="warning"
    >
        <p>{{ 'time-tracking.pendingHoursOnProjectArchive' | translate }}</p>
    </ui-banner>
    <p [innerHTML]="'time-tracking.confirmArchiveProject' | translate"></p>
</ui-confirmation-dialog>

<ui-confirmation-dialog
    header="time-tracking.projectCannotBeDeleted"
    primaryButtonLabel="close"
    secondaryButtonLabel="archive"
    secondaryButtonType="outline"
    #archiveInsteadModal
>
    <p>{{ 'time-tracking.projectCannotBeDeletedExplainerLine1' | translate }}</p>
    <p>{{ 'time-tracking.projectCannotBeDeletedExplainerLine2' | translate }}</p>
</ui-confirmation-dialog>

<div class="page-container no-scroll" [class.loading]="isLoading">
    <app-header [title]="'time-tracking.indexProjectsPage.title'" [menuService]="menuService">
        <ui-button *ngIf="isAdmin" class="buttons" type="primary" [routerLink]="'create'"
            ><mat-icon svgIcon="plus"></mat-icon>{{ 'time-tracking.indexProjectsPage.createButton' | translate }}
        </ui-button>
    </app-header>
    <ui-card class="scrollable-table-container" [withMargin]="false" [withSpacing]="false">
        <app-table
            [isResponsive]="true"
            [noPadding]="true"
            [embedded]="true"
            [showOffset]="true"
            [table]="table"
            (menuItemSelected)="menuAction($event)"
        >
            <app-empty-state
                label="{{
                    (table.isEmpty
                        ? 'time-tracking.indexProjectsPage.noProjects'
                        : 'time-tracking.indexProjectsPage.noProjectsInFilter'
                    ) | translate
                }}"
                src="/assets/illustrations/empty-box.png"
            ></app-empty-state>
        </app-table>
    </ui-card>
</div>
